import React from 'react';
import { InstanceDetailsComponent}  from './InstanceDetails.Component';
import { httpServices }  from '../../../services/httpServices';
import { ErrorPage } from '../../common/error';
import { CustomProgressBar } from '../../common/CustomProgressBar';
import { history } from '../../../helpers/history';

const formFields = {
    src_user: '',
    dest_user: '',
    src_location: 0,
    dest_location: 0,
    status : 1,
    editId : '',
};
const BASE_PATH = process.env.REACT_APP_BASE_PATH;
export class InstanceDetailsContainer extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            hasPermission: false,
            staffView: false,
            staffEdit: false,
            locationView: false,
            locationEdit: false,
            dataLoaded: false,
            cancel : false,
            save :false,
            source_staff_list: [],
            source_user_list: [],
            destination_user_list: [],
            destination_staff_list: [],
            formFields : formFields,
            errors : {},
            destination_instance: '',
            staff_mapped : [],
            user_mapped : [],
            snackbarOpen : false,
            snackbarMsg : '',
            snackbarVariant : '',
            editStatus:'',
            editId:'',
            src_location_list : [],
            dest_location_list : [],
            showLoader: false,
            open : false,
            deleteId : 0,
            mapOption : '',
            srcFullName : '',
            sourceLocationName : ''
        };
        this.getList = this.getList.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.delete = this.delete.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleStatusChange =this.handleStatusChange.bind(this);
        this.resetFields = this.resetFields.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onView = this.onView.bind(this);
        this.onDeleteLocation = this.onDeleteLocation.bind(this);
    }
    componentDidMount = () => {
        this.setState({destination_instance : this.props.location.state.instanceName});
        this.getList(this.props.location.state.instanceName);
    }; 
    getList = (destination_instance) => {
        this.setState({
            showLoader: true
        });
        let apiEndpoint = 'api/settings/syncinstance/list';
            return httpServices.post(apiEndpoint, {destination_instance: destination_instance})
                .then(response => {
                    if (response.data.permission) {
                        let staffView = response.data.staff_view;
                        let staffEdit = response.data.staff_edit;
                        let locationView = response.data.location_view;
                        let locationEdit = response.data.location_edit;
                        let source_staff_list = staffView ? response.data.source_staff_list : [];
                        let destination_staff_list = staffView ? response.data.destination_staff_list : [];                        
                        let source_user_list = staffView ? response.data.source_user_list : [];
                        let destination_user_list = staffView ? response.data.destination_active_user_list : [];
                        let staff_mapped = staffView ? response.data.staff_mapped : [];
                        let user_mapped = staffView ? response.data.user_mapped : [];
                        let src_location_list = locationView ? response.data.locations : [];
                        let dest_location_list = locationView ? response.data.destination_location_data : [];
                        let location_mapped = locationView ? response.data.location_mapped : [];
                        this.setState({
                            hasPermission: true,
                            dataLoaded: true,
                            staffView: staffView,
                            staffEdit: staffEdit,
                            locationView: locationView,
                            locationEdit: locationEdit,
                            source_staff_list: source_staff_list,
                            destination_user_list: destination_user_list,                            
                            source_user_list: source_user_list,
                            destination_staff_list: destination_staff_list,
                            staff_mapped: staff_mapped,
                            user_mapped: user_mapped,
                            src_location_list: src_location_list,
                            dest_location_list: dest_location_list,
                            location_mapped: location_mapped,
                            showLoader: false
                        });
                    } else{
                        this.setState({
                            dataLoaded: true,
                            showLoader: false
                        });
                    }
                })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
    };
    onClose = () =>{
        let ff = this.state.formFields;
        ff['status'] = null;

        this.setState({
            open: false,
            staffDelete: false,
            locationDelete: false,
            errors:{},
            deleteConfirm : false,
            formFields : ff 
        });
        this.clearForm();
    }

    clearForm = () => {
        let ff = this.state.formFields;
        ff['status'] = 1;
        this.setState({
            errors: {},
            errorMessage: false,
            formFields : {} 
        });
    };
    handleSubmit = (map_option, map_id = null) => {
        if (this.handleValidation(map_option)) {
            let data = this.state.formFields;
            data.destination = this.state.destination_instance;
            data.map_option = map_option;
            let success_message ='';
            let apiEndpoint = '';
            if (map_option == 'user') {
                success_message = "User added successfully";
                apiEndpoint = 'api/settings/syncinstance/saveUserMapping';
            }
            if (map_option == 'location') {
                success_message = "Location added successfully";
                apiEndpoint = 'api/settings/syncinstance/saveLocationMapping';
            }
            if(map_id) {
                data.user_map_id = map_id;
            }
            if (data) {
                return httpServices.post(apiEndpoint, data)
                    .then(response => {
                        if (response.data.status) {
                            this.getList(this.state.destination_instance);
                            this.setState({
                                snackbarOpen: true,
                                snackbarMsg: success_message,
                                snackbarVariant: 'success'
                            });
                        }
                        else {
                            this.setState({
                                snackbarOpen: true,
                                snackbarMsg: response.data.error,
                                snackbarVariant: 'error'
                            });
                        }
                        this.resetFields();
                    })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
            }
        }
    }
    resetFields = () => {
        let fields = this.state.formFields;
        fields['src_user'] = '';
        fields['dest_user'] = '';
        fields['src_user'] = '';
        fields['dest_user'] = '';
        fields['src_location'] = 0;
        fields['dest_location'] = 0;
        fields['status'] = 1;
        fields['editSrcPath'] = '';
        fields['editDestPath'] = '';        
        this.setState({ formFields: fields});
    } 
    handleOnChange = (evt, value) => {
        const field = evt.target.name;
        const ff = this.state.formFields;
        ff[field] = evt.target.value;
        this.setState({
            formFields : ff
        });
    };
    handleValidation(map_option) {
        let formIsValid = true;
        let errors = {};
        if(map_option == 'staff'){
            if (!this.state.formFields.src_staff) {
                errors["src_staff"] = "Cannot be empty";
                formIsValid = false;
            }
            if (!this.state.formFields.dest_staff) {
                errors["dest_staff"] = "Cannot be empty";
                formIsValid = false;
            }
        }
        else if (map_option == 'user') {
            if (!this.state.formFields.src_user) {
                errors["src_user"] = "Cannot be empty";
                formIsValid = false;
            }
            if (!this.state.formFields.dest_user) {
                errors["dest_user"] = "Cannot be empty";
                formIsValid = false;
            }
        }
        else if (map_option == 'location') {
            if (!this.state.formFields.src_location) {
                errors["src_location"] = "Cannot be empty";
                formIsValid = false;
            }
            if (!this.state.formFields.dest_location) {
                errors["dest_location"] = "Cannot be empty";
                formIsValid = false;
            }
        }
        this.setState({errors : errors});
        return formIsValid;
    }
    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }
    onDelete = (delete_id, src_full_name, map_option) => {
        this.setState({staffDelete : true, deleteId : delete_id, srcFullName : src_full_name, mapOption : map_option});
    }
    onView = (id) => {
        if (id) {
            history.push(BASE_PATH + '/system/instancedetails/view/' + this.state.destination_instance + '/' +id);
        }
    }
    onDeleteLocation = (delete_id, source_location_name, map_option) => {
        this.setState({locationDelete : true, deleteId : delete_id, sourceLocationName : source_location_name, mapOption : map_option});
    }
    delete = () =>{
        this.setState({staffDelete : false, locationDelete : false});
        let delete_id = this.state.deleteId;
        let map_option = this.state.mapOption;
        if (delete_id) {
            let success_message = '';
            if (map_option == 'staff') {
                success_message = "User deleted successfully";
            }
            else if (map_option == 'location') {
                success_message = "Location deleted successfully";
            }
            let apiEndpoint = 'api/settings/syncinstance/delete';
            return httpServices.post(apiEndpoint,{delete_id, map_option})
                .then(response => {
                    if (response.data.status) {
                        this.getList(this.state.destination_instance);
                        this.setState({
                            snackbarOpen: true,
                            snackbarMsg: success_message,
                            snackbarVariant: 'success'
                        });
                    } else {
                        this.setState({
                            snackbarOpen: true,
                            snackbarMsg: "Delete failed!",
                            snackbarVariant: 'error'
                        });
                    }
                })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
        }
    }    
    handleStatusChange = (evt, value) => {
        const field = evt.target.name;
        this.setState({
            editStatus : evt.target.value
        });
    };
    render(){
        return(
            <>
            <CustomProgressBar
                loaderOpen={this.state.showLoader}
            />
            {(this.state.dataLoaded) ?
                (this.state.hasPermission)
                ?
                <InstanceDetailsComponent
                    SourceStaffList = {this.state.source_staff_list}
                    SourceUserList = {this.state.source_user_list}
                    DestinationUserList = {this.state.destination_user_list}
                    FormFields = {this.state.formFields}
                    HandleOnChange = {this.handleOnChange}
                    Errors = {this.state.errors}
                    HandleSubmit ={this.handleSubmit}
                    DestinationStaffList = {this.state.destination_staff_list}
                    DestinationInstance = {this.state.destination_instance}
                    StaffMapped = {this.state.staff_mapped}
                    UserMapped = {this.state.user_mapped}
                    SnackbarOpen = {this.state.snackbarOpen}
                    Open = {this.state.open}
                    SnackbarMsg = {this.state.snackbarMsg}
                    SnackbarVariant = {this.state.snackbarVariant}
                    SnackbarClose = {this.snackbarClose}
                    Delete = {this.delete}
                    SourceLocationList = {this.state.src_location_list}
                    DestinationLocationList = {this.state.dest_location_list}
                    LocationMapped = {this.state.location_mapped}
                    StaffView = {this.state.staffView}
                    StaffEdit = {this.state.staffEdit}
                    LocationView = {this.state.locationView}
                    LocationEdit = {this.state.locationEdit}
                    EditId = {this.state.editId}
                    EditStatus = {this.state.editStatus}
                    Close = {this.onClose}
                    HandleStatusChange ={this.handleStatusChange}
                    StaffDelete = {this.state.staffDelete}
                    OnDeleteStaff = {this.onDelete}
                    OnView = {this.onView}
                    LocationDelete = {this.state.locationDelete}
                    OnDeleteLocation = {this.onDeleteLocation}
                    SrcFullName = {this.state.srcFullName}
                    SourceLocationName = {this.state.sourceLocationName}

                />
                : <ErrorPage Message={'You are not authorized to view this page.'} />
            :<></>
            }
            </>
        )
    }
}
